import {isJsonString} from "@js/globalFunctions/isJsonString";

export function determineSearchCount(data){
	let searchCount;
	if(isJsonString(data))
	{
		const result = JSON.parse(data);
		searchCount = result.total;
	}
	else
	{
		if(data.indexOf(',') !== -1)
		{
			searchCount = data.split(',')[0];
		}
		else
		{
			searchCount = data;
		}
	}
	return searchCount;
}
